export default __webpack_public_path__ + "media/images/mailer-new/welcome/checkbox-on-8a7d037fc27e142446e8d86807bded4b.png";